import React, { useEffect, useState } from 'react';

interface CountdownTimerProps {
  deadline: string;
  compact?: boolean;
}

function getCountdown(deadline: string) {
  const diff = new Date(deadline).getTime() - Date.now();
  if (diff <= 0) return { label: 'Overdue', urgency: 'overdue' as const };

  const totalMins = Math.floor(diff / 60000);
  const hours = Math.floor(totalMins / 60);
  const mins = totalMins % 60;
  const days = Math.floor(hours / 24);

  let label = '';
  if (days > 1) label = `${days}d ${hours % 24}h left`;
  else if (hours > 0) label = `${hours}h ${mins}m left`;
  else label = `${mins}m left`;

  const urgency =
    totalMins < 60 ? ('urgent' as const) :
    totalMins < 120 ? ('warning' as const) :
    ('ok' as const);

  return { label, urgency };
}

export default function CountdownTimer({ deadline, compact = false }: CountdownTimerProps) {
  const [state, setState] = useState(() => getCountdown(deadline));

  useEffect(() => {
    const id = setInterval(() => setState(getCountdown(deadline)), 60000);
    return () => clearInterval(id);
  }, [deadline]);

  return (
    <span className={`countdown countdown-${state.urgency} ${compact ? 'countdown-compact' : ''}`}>
      {state.urgency === 'overdue' ? (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="12" height="12">
          <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
      ) : (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="12" height="12">
          <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
        </svg>
      )}
      {state.label}
    </span>
  );
}
